
import React from 'react';
import { useMasterLicense } from '@/hooks/useMasterLicense';
import MasterLicenseSettingsLayout from '@/components/masterlicense/settings/MasterLicenseSettingsLayout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import ProfileForm from '@/components/profile/ProfileForm';
import NotificationSettings from '@/components/profile/NotificationSettings';
import { useToast } from '@/hooks/use-toast';

const MasterLicenseProfile: React.FC = () => {
  const { isLoading, handleLogout, user } = useMasterLicense();
  const [activeTab, setActiveTab] = React.useState("profile");
  const { toast } = useToast();

  const handleProfileUpdate = async (data: any) => {
    toast({
      title: "Profile Updated",
      description: "Your profile information has been updated successfully.",
    });
    return Promise.resolve();
  };

  return (
    <MasterLicenseSettingsLayout
      isLoading={isLoading}
      handleLogout={handleLogout}
      userRole={user?.role || 'Master Admin'}
      activeTab="profile"
    >
      <div className="container max-w-6xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">My Profile</h1>
        
        <Card className="mb-8">
          <CardHeader className="pb-2">
            <CardTitle>Master Admin Profile</CardTitle>
            <CardDescription>Your account information</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-primary rounded-full h-16 w-16 flex items-center justify-center text-white text-2xl font-bold">
                {user?.user_metadata?.first_name?.charAt(0) || user?.email?.charAt(0) || 'M'}
              </div>
              <div>
                <h2 className="text-xl font-semibold">{user?.user_metadata?.first_name || user?.user_metadata?.name || 'Master Admin'}</h2>
                <p className="text-gray-500">{user?.email || 'master@referme.site'}</p>
                <span className="inline-block mt-1 px-2 py-0.5 bg-orange-100 text-orange-800 rounded-full text-xs font-medium">
                  Master Administrator
                </span>
              </div>
            </div>
          </CardContent>
        </Card>
        
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="mb-8">
            <TabsTrigger value="profile">Profile</TabsTrigger>
            <TabsTrigger value="notifications">Notifications</TabsTrigger>
          </TabsList>
          
          <TabsContent value="profile">
            <ProfileForm 
              user={user} 
              onProfileUpdate={handleProfileUpdate} 
            />
          </TabsContent>
          
          <TabsContent value="notifications">
            <NotificationSettings userId={user?.id || ''} />
          </TabsContent>
        </Tabs>
      </div>
    </MasterLicenseSettingsLayout>
  );
};

export default MasterLicenseProfile;
